import React from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import { citations } from '@Constants';
import { FEATURES } from '@Constants/rx-ui/constants';
import GroupSingleDatabase from '@Containers/ResultsPreview/GroupSingleDatabase';
import GroupMultipleDatabases from '@Containers/ResultsPreview/GroupMultipleDatabases';
import ResultsPreviewAIBanner from '@Containers/ResultsPreview/Components/ResultsPreviewAIBanner';
import isAIEnhancedPreviewItem from '@Containers/ResultsPreview/utils';

import './ResultsPreview.scss';

const shouldPrioritizePreviewItem = (previewItem) =>
  previewItem.context === citations ? previewItem.semanticSearchIncluded === true : previewItem.assistantEligible === true;

function orderPreviewItems(previewItems) {
  const aiItems = [];
  const nonAiItems = [];

  previewItems.forEach((previewItem) => {
    if (shouldPrioritizePreviewItem(previewItem)) {
      aiItems.push(previewItem);
      return;
    }

    nonAiItems.push(previewItem);
  });

  return [...aiItems, ...nonAiItems];
}

function ResultsPreview({
  cancelQuery,
  cancelQueriesInGroup,
  previewItems,
  showMoreResults,
  showStructurePopup,
  copyQuery,
  createAlert,
  redirectToResults,
}) {
  const bioactivityVisualizationButtonEnabled = Auth.isFeatureEnabled(FEATURES.enableBioactivityVisualizationButtonOnPreviewResults);
  const orderedPreviewItems = orderPreviewItems(previewItems);
  const hasAIEligiblePreviewItem = orderedPreviewItems.some(isAIEnhancedPreviewItem);

  return (
    <div
      id="main-content"
      className="quick-results-preview results-preview e2e-quick-results-container"
      aria-label="Quick Search Results List"
      role="search">
      {hasAIEligiblePreviewItem && (
        <div className="results-preview__ai-banner-wrapper">
          <ResultsPreviewAIBanner />
        </div>
      )}
      {orderedPreviewItems.map((previewItem, previewItemIndex) =>
        previewItem.multipleDatabases ? (
          <GroupMultipleDatabases
            key={previewItem.queryId}
            previewItem={previewItem}
            showMoreResults={showMoreResults}
            showStructurePopup={showStructurePopup}
            copyQuery={copyQuery}
            createAlert={createAlert}
            redirectToResults={redirectToResults}
            cancelQuery={cancelQuery}
            cancelQueriesInGroup={cancelQueriesInGroup}
            expandedByDefault={previewItemIndex === 0}
          />
        ) : (
          <GroupSingleDatabase
            key={previewItem.queryId}
            previewItem={previewItem}
            previewItemIndex={previewItemIndex}
            showMoreResults={showMoreResults}
            bioactivityVisualizationButtonEnabled={bioactivityVisualizationButtonEnabled}
            showStructurePopup={showStructurePopup}
            copyQuery={copyQuery}
            createAlert={createAlert}
            redirectToResults={redirectToResults}
            cancelQueriesInGroup={cancelQueriesInGroup}
          />
        )
      )}
    </div>
  );
}

ResultsPreview.propTypes = {
  cancelQuery: PropTypes.func.isRequired,
  cancelQueriesInGroup: PropTypes.func.isRequired,
  previewItems: PropTypes.array.isRequired,
  showMoreResults: PropTypes.func.isRequired,
  showStructurePopup: PropTypes.func.isRequired,
  copyQuery: PropTypes.func.isRequired,
  createAlert: PropTypes.func.isRequired,
  redirectToResults: PropTypes.func.isRequired,
};

export default ResultsPreview;
